<template>
    <v-container fluid class="ma-0 pa-0">
        <v-card class="fill-height" tile>
            <v-toolbar :color="moduleColor" dense dark>
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" @click="close()">
                            <v-icon>mdi-menu-open</v-icon>
                        </v-btn>
                    </template>
                    <span>Hide Order Line Up</span>
                </v-tooltip>
                <v-toolbar-title>
                    Order Line Up
                    <v-progress-linear v-if="loading.lineup" indeterminate size="24"
                        :color="moduleColor + ' lighten-3'"></v-progress-linear>
                </v-toolbar-title>
                <v-spacer> </v-spacer>

                <v-toolbar-items>
                    <v-btn icon>
                        <v-icon @click="viewOrder(order)">mdi-file-find</v-icon></v-btn>
                    <v-btn icon @click="getOrders()" :loading="loading.lineup" :disabled="loading.lineup">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn icon @click="openOrderForm()" :loading="loading.lineup">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-menu bottom left offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item v-for="(item, index) in lineUpMenuItems" @click="item.action()" :key="index">
                                <v-list-item-icon>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar-items>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-combobox label="Station Type" cols="6" v-model="type" :items="types" dense :item-text="'Type'"
                    :item-value="'id'" @change="printLog()"></v-combobox>
                <v-combobox label="Filters" cols="6" v-model="filterOrd" :items="filters" dense
                    @change="printLog()"></v-combobox>
                <v-text-field label="Search" dense v-model="search"></v-text-field>
            </v-container>
            <div style="height: 65vh; overflow-y: auto;">
                <v-data-table fixed-header dense :headers="headers" :items="filteredOrders" :loading="loading.lineup"
                    item-key="OrderID" :items-per-page="-1" :disable-pagination="true" :hide-default-footer="true"
                    style="max-height:700px;">
                    <template v-slot:body="props">
                        <draggable :list="props.items" :group="'OrderID'" @end="onDragEnd" @start="onDragStart"
                            @add="onAddOrder" tag="tbody" style="min-height: 200px;padding: 20px;" :delay="0"
                            ghost-class="ghost" animation="100">
                            <tr v-for="(order, index) in props.items" :key="order.OrderID" class="py-2">
                                <td class="custom-cell">
                                    {{ order.RTHrs }}
                                </td>
                                <td class="custom-cell">
                                    {{ order.ROHrs }}
                                </td>
                                <td class="custom-cell">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip v-bind="attrs" v-on="on" label
                                                :color="order.is_automatic === 1 ? 'green' : 'grey'" class="small-text">
                                                {{ order.OrderID }}
                                            </v-chip>
                                        </template>
                                        <span>{{ order.is_automatic === 1 ? 'Automatic' : 'Manual' }}</span>
                                    </v-tooltip>
                                </td>

                                <td class="custom-cell">
                                    <v-icon small :color="order.TerminalColor">
                                        mdi-water-pump
                                    </v-icon>
                                </td>
                                <td class="custom-cell">
                                    {{ order.TerminalName }}
                                </td>
                                <td class="custom-cell">
                                    {{ order.StationName }}
                                </td>
                                <td class="custom-cell">
                                    <!-- {{ formatIndependentTime(order.EH) }} -->
                                    {{ order.AVGHE }}
                                </td>
                                <td class="custom-cell">
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon small v-on="on" @click="
                                                $emit('load-details', order)
                                                ">
                                                <v-icon
                                                    :color="order.OrderStatus == 'ACTIVE' ? '' : 'green'">mdi-file-document-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            {{ order.Trailer }}
                                        </span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    <v-icon v-if="order.isSpecific == 1" color="#e6c10b" small>mdi-star</v-icon>
                                </td>
                            </tr>
                        </draggable>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <vue-context ref="shortShifts" :style="{ top: `${menuY}px`, left: `${menuX}px` }">
            <template slot-scope="selectedOrder">
                <li>
                    <a>
                        Show Shifts
                    </a>
                </li>
            </template>
        </vue-context>
        <OrdersForm v-if="$store.state.order.add" :back="true" />
        <DispatchReports :value="dialogs.dispatchReports" :customers="customers"
            @input="dialogs.dispatchReports = $event" />
        <ShortShift v-if="vDialogShifts" :vDialogShifts="vDialogShifts" :ShiftsInfo="ShiftsInfo"
            @close="vDialogShifts = false;"></ShortShift>

        <confirm-dialogue ref="confirmDialogue" />
    </v-container>
</template>

<script>
import axios from 'axios';
import draggable from 'vuedraggable';

import { dateUtils } from '../../mixins/dateUtils.js';

import OrdersForm from '../../Modals/Dispatch/Orders/AddOrder.vue';
import DispatchReports from '../../Modals/Dispatch/Dispatch/DispatchReports';
import ConfirmDialogue from '../../Modals/ConfirmDialogue.vue';
import ShortShift from '../../Modals/Dispatch/Dispatch/Order/ShowShifts.vue';
import VueContext from 'vue-context';

export default {
    name: 'OrderLineUp',
    components: {
        VueContext,
        draggable,
        DispatchReports,
        ConfirmDialogue,
        OrdersForm,
        ShortShift
    },
    props: ['moduleColor', 'customers', 'shiftHeader', 'newRegion'],
    mixins: [dateUtils],
    data: () => ({
        menuX: 0,
        menuY: 0,
        filters: ['Terminal', 'Station', 'OrderID', 'StationCity'],
        filterOrd: 'OrderID',
        search: '',
        headers: [
            {
                text: 'RT',
                value: 'RTHrs',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },
            {
                text: 'RO',
                value: 'ROHrs',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },
            {
                text: 'ID',
                value: 'OrderID',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },

            {
                text: 'B',
                value: 'Bdg',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },
            {
                text: 'Terminal',
                value: 'TerminalName',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },
            {
                text: 'Station',
                value: 'StationName',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },
            {
                text: 'EH',
                value: 'EH',
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },
            {
                text: 'Dtl',
                value: 'details',
                sortable: false,
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            },

            {
                text: '★',
                value: '★',
                sortable: false,
                class: 'custom-header',
                cellClass: 'custom-cell',
                align: 'center'
            }
        ],
        orderDetailHeaders: [
            [
                { text: 'Product', value: 'ProductType' },
                { text: 'Product Code', value: 'ProductCode' },
                { text: 'Quantity', value: 'DispatchedQuantity' },
                { text: 'Normalized Quantity', value: 'NormalizedQuantity' }
            ]
        ],
        orders: [],
        orderCopy: [],
        Shifts: [],
        orderGroup: {
            name: 'orders',
            pull: true,
            put: true
        },
        drag: false,
        loading: {
            lineup: true
        },
        dialogs: {
            dispatchReports: false
        },
        vDialogShifts: false,

        types: [
            { id: 0, Type: 'All' },
            { id: 1, Type: 'Contracted' },
            { id: 2, Type: 'Private' },
            { id: 3, Type: 'Interplant' }
        ],
        type: [],
    }),
    watch: {
        'newRegion': function () {
            console.log(this.newRegion)
        },
    },
    computed: {
        filteredRegion() {
            return this.orders.filter(i => {
                return (
                    !this.newRegion || i.PrincipalRegionID == this.newRegion
                );
            });
        },
        filteredStationType() {
            if (this.type.id == 0) {
                return this.filteredRegion;
            } else {
                return this.filteredRegion.filter(i => {
                    return (!this.type || i.StationType == this.type.id);
                });
            }
        },
        filteredOrders() {
            let value;
            return this.filteredStationType.filter(i => {
                if (this.filterOrd == 'Terminal') {
                    value = i.TerminalName;
                }

                if (this.filterOrd == 'Station') {
                    value = i.StationName;
                }

                if (this.filterOrd == 'StationCity') {
                    value = i.StationCity;
                }

                if (this.filterOrd == 'OrderID') {
                    value = i.OrderID;
                }
                return (
                    !this.search ||
                    (value &&
                        value
                            .toString()
                            .toLowerCase()
                            .includes(this.search.toLowerCase()))
                );
            });
        },

        lineUpMenuItems() {
            let items = [];
            items.push({
                title: "Update ETA's",
                action: () => {
                    this.updateETAHrs();
                },
                icon: 'mdi-timer-refresh-outline',
                condition: true
            });
            items.push({
                title: 'Open Dispatch Report Window',
                action: () => {
                    this.openDispatchReports();
                },
                icon: 'mdi-file-chart',
                condition: true
            });
            items.push({
                title: 'Delete Contracted Orders from LineUp',
                action: () => {
                    this.deleteContractedOrders();
                },
                icon: 'mdi-delete',
                condition: true
            });
            items.push({
                title: 'Refresh Pending Orders',
                action: () => {
                    this.updatePendingOrders();
                },
                icon: 'mdi-file-document-refresh',
                condition: true
            });
            items.push({
                title: 'Reload LineUp',
                action: () => {
                    this.getOrders();
                },
                icon: 'mdi-refresh',
                condition: true
            });
            items.push({
                title: 'Hide LineUp',
                action: () => {
                    this.close();
                },
                icon: 'mdi-menu-open'
            });
            return items;
        }
    },

    methods: {
        onAddOrder() {
            this.getOrders();
        },
        openContextMenu(order) {
            this.menuX = event.clientX;
            this.menuY = event.clientY;
            this.$refs.shortShifts.open(order);
        },
        menuAction(option) {
            console.log("Opción seleccionada:", option);
            this.showContextMenu = false;
        },
        viewOrder: async function (ord) {
            const orderNum = await prompt("Enter an Order Number");
            if (orderNum) {
                this.$store.state.isLoading = true;
                axios
                    .get('short/shifts/' + orderNum + '/' + this.$store.state.shiftId.ShiftId)
                    .then(response => {
                        console.log(response.data);
                        this.ShiftsInfo = response.data;
                        this.vDialogShifts = true;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
            }
        },
        close() {
            this.$emit('close');
        },
        async getOrders() {
            this.loading.lineup = true;
            try {
                const response = await axios.post('v2/orders/filter', {
                    status: ['ACTIVE']
                });
                this.orders = response.data;
                this.orderCopy = response.data;
                this.loading.lineup = false;
            } catch (error) {
                console.error(error);
            }
        },
        recopyOrders() {
            this.orders = JSON.parse(JSON.stringify(this.orderCopy));
        },
        printLog: function () {
            console.log(this.filterOrd);
        },
        openOrderForm: function () {
            this.$store.state.order.add = true;
            this.back = true;
            this.$store.state.editedOrder.id = null;
            this.$store.state.editedOrder.StationID = null;
            this.$store.state.editedOrder.destiny = 1;
        },
        async updateETAHrs() {
            this.loading.lineup = true;
            try {
                response = await axios.get('recalculate/eta/hrs/' + this.shiftHeader);
            } catch (error) {
                console.error(error);
            } finally {
                this.loading.lineup = false;
            }
        },
        openDispatchReports() {
            this.dialogs.dispatchReports = true;
        },
        async deleteContractedOrders() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete orders',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            if (ok) {
                var str = this.$store;
                str.state.isLoading = true;
                axios
                    .post('order/all/retain', {})
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        console.log(response.data);
                        this.loadOrderLineUp();
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Orders removed successfully.'
                        });
                        str.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error.response);
                        console.log(error.response.status);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        if (error.response.status == 405) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'Failed to delete order, already dispatched.'
                            });
                        }
                        str.state.isLoading = false;
                    });
            }
        },
        onDragStart() {
            this.$store.state.OnFrom = 'LineUp';
        },
        onDragEnd(event) {
            if (event.from !== event.to) {
                const order = event.item;
                order.OrdLoadStatus = 'READYTOSEND';
                console.info('Event:', event);
            }
        },
        updatePendingOrders() {
            this.$store.state.isLoading = true;

            var str = this.$store;
            str.dispatch('setSnackbar', {
                color: 'error',
                text:
                    'Sent update readings request, this process takes a few minutes.'
            });

            axios
                .get('/ftp-readings/update')
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Readings Update Complete, Refresh page'
                    });
                    console.log(response.data);
                    this.getOrders();
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        }
    },
    mounted() {
        this.type = this.types[0];
        this.getOrders();
    }
};
</script>

<style>
.grab-icon {
    cursor: grab;
}

.custom-header {
    font-weight: bold;
    padding: 0 4px !important;
    text-align: center;
}

.custom-cell {
    padding: 0 4px !important;
    font-size: 0.7rem !important;
}

.ghost {
    opacity: 0;
    transition: opacity 0.1s ease;
    /* Ajusta la duración si necesitas más velocidad */
}

.small-text {
    font-size: 11px !important;
    margin: 0px !important;
    padding: 10px !important;
    height: 22px !important;
    color: white !important;
}
</style>